import React, { useEffect, useState, Fragment } from "react";
import { useLocation, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Url } from "../../utils/Url/Url";
import WrapperPerfil from "../../components/CompanyProfile/WrapperPerfil";

function PerfilEmpresa() {
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [company, setcompany] = useState("");
  const [tab, settab] = useState(1);
  const [activeTab, setactiveTab] = useState("tab-about");
  const [flag, setflag] = useState(false);
  const params = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    let idEmpresa = 0;
    if (params.id !== undefined) {
      idEmpresa = params.id;
    } else {
      idEmpresa = state.profileId;
    }
    axios.get("access/company-profile/" + idEmpresa, config).then((result) => {
      setcompany(result.data);
      setLoading(false);
    });
  }, []);

  const pp = { widgt: "146px", height: "138px" };
  const ppBanner = {
    width: "100%",
    height: "100%",
  };
  function CallTab(id, li) {
    settab(id);

    let act = document.getElementById(activeTab);
    let newActive = document.getElementById(li);

    act.classList.remove("profile__tabs--active");
    newActive.classList.add("profile__tabs--active");

    setactiveTab(li);
  }
  const cover = { background: "none" };
  function ReloadData() {
    setflag(flag ? false : true);
  }
  return (
    <div class="vacantes perfil-empresa profile mb-5">
      <Fragment>
        <div class="container">
          <div class="row">
            <div class="body-profile">
              <div class="profile__header">
                <div class="profile__header-container">
                  <div class="profile__cover-photo" style={cover}>
                    <img
                      id="bannerPic"
                      src={company.coverImage}
                      class="no-cover-image"
                      alt="No cover photo"
                      style={ppBanner}
                    ></img>
                  </div>
                  <div class="profile__header-info">
                    <div class="profile__header-info-left">
                      <div class="profile__header-info-left-wrapper">
                        <div class="profile__header-info-photo">
                          <img
                            className="infor-photo"
                            src={company.image}
                            style={pp}
                          ></img>
                        </div>
                        <div class="profile__header-info-description">
                          <div class="profile__header-info-description-name">
                            {company.name}
                          </div>
                          <div class="profile__header-info-description-slogan">
                            {company.slogan}
                          </div>
                          <a
                            href="#"
                            className="btn--gradient btn--gradient-small py-2 px-3"
                            onClick={() => {
                              let host = window.location.hostname;
                              //in the case host having a port, include it in the url
                              if (window.location.port) {
                                host = host + ":" + window.location.port;
                              }
                              // Asegurarse de que el protocolo sea https
                              let protocol =
                                window.location.protocol === "https:"
                                  ? "htpps"
                                  : "http";
                              let finalUrl = `${protocol}://${host}/compartir/empresa/${company.companyProfileId}`;
                              let Title = `${company.name}`;
                              let body = `Te comparto la empresa ${company.name} en Krezco, la red social de desarrollo profesional`;
                              navigator.share({
                                title: Title,
                                url: finalUrl,
                                text: body,
                              });
                            }}
                          >
                            <i className="fas fa-share-alt text-white"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="profile__header-info-right">
                      <div class="profile__header-info-right-wrapper"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="profile__tabs ">
                <div class="container bordered-box">
                  <div class="row">
                    <div class="col col-md-12">
                      <div class="profile__tabs-items">
                        <ul>
                          <li
                            id="tab-about"
                            className="profile__tabs--active"
                            onClick={() => CallTab(1, "tab-about")}
                          >
                            Acerca de Nosotros
                          </li>
                          <li
                            id="tab-empleo"
                            onClick={() => CallTab(2, "tab-empleo")}
                          >
                            Empleos
                          </li>
                          <li
                            id="tab-formaciones"
                            onClick={() => CallTab(3, "tab-formaciones")}
                          >
                            Formaciones
                          </li>
                          <li
                            id="tab-eventos"
                            onClick={() => CallTab(7, "tab-eventos")}
                          >
                            Eventos
                          </li>
                          <li
                            id="tab-fotosvideos"
                            onClick={() => CallTab(5, "tab-fotosvideos")}
                          >
                            Fotos / Videos
                          </li>
                          <li
                            id="tab-valoraciones"
                            onClick={() => CallTab(6, "tab-valoraciones")}
                          >
                            Buenas Practicas
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <label className="login-label">CARGANDO</label>
        ) : (
          <div class="container">
            <div class="row vacancy__content">
              <div class="col-12 col-md-5">
                <div
                  class="vacancy__sidebar bordered-box"
                  style={{ marginTop: "0px" }}
                >
                  <div class="bordered-box__header">
                    <div class="bordered-box__header-title">Información</div>
                  </div>
                  <div class="vacancy__sidebar-content">
                    <ul>
                      <li>
                        <strong>Sitio Web:</strong>{" "}
                        <a
                          href={Url(company.webSite)}
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          {Url(company.webSite)}
                        </a>
                      </li>
                      <li>
                        <strong>Sector:</strong> {company.sectorId.name}
                      </li>
                      <li>
                        <strong>Ubicación:</strong> {company.ubication}
                      </li>
                      <li>
                        <strong>Año de Fundación:</strong> {company.fundation}
                      </li>
                      <li>
                        <strong>Empleados:</strong> {company.employes}
                      </li>
                    </ul>

                    <ul class="social-media">
                      {company.linkTwitter && (
                        <li>
                          <a href={Url(company.linkTwitter) ?? ""}>
                            <i className="fab fa-twitter-square 1"></i>
                          </a>
                        </li>
                      )}

                      {company.linkFacebook && (
                        <li>
                          <a href={Url(company.linkFacebook) ?? ""}>
                            <i className="fab fa-facebook-square 1"></i>
                          </a>
                        </li>
                      )}

                      {company.linkInstagram && (
                        <li>
                          <a href={Url(company.linkInstagram) ?? ""}>
                            <i className="fab fa-instagram-square 1"></i>
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-7">
                <WrapperPerfil
                  id={tab}
                  company={company}
                  reload={ReloadData}
                  edit={false}
                ></WrapperPerfil>
              </div>
            </div>
          </div>
        )}
      </Fragment>
    </div>
  );
}

export default PerfilEmpresa;
